<template>
  <div>
    <b-row class="my-1">
      <b-col md="6">
        <h4>Description</h4>
      </b-col>
      <b-col md="6">
        <h4>Allergy Note</h4>
      </b-col>
      <b-col md="3">
        <h6>En</h6>
        <span>{{ item.description.en || 'Empty' }}</span>
      </b-col>
      <b-col md="3">
        <h6>Ar</h6>
        <span>{{ item.description.ar || 'Empty' }}</span>
      </b-col>
      <b-col md="3">
        <h6>En</h6>
        <span>{{ item.allergyNote.en || 'Empty' }}</span>
      </b-col>
      <b-col md="3">
        <h6>Ar</h6>
        <span>{{ item.allergyNote.ar || 'Empty' }}</span>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col md="7">
        <h4>Availability Hours</h4>
        <b-table
          hover
          striped
          :items="item.availability.hours"
          :fields="tableColumns"
        >
          <template #cell(available)="data">
            <span>{{ data.item.available? 'Yes': 'No' }}</span>
          </template>
        </b-table>
      </b-col>
      <b-col md="5">
        <h4>Availability Dates</h4>
        <b-table
          hover
          striped
          :items="datesArr"
          :fields="datesCols"
        >
          <template #cell(available)="data">
            <span>{{ data.item.available? 'Yes': 'No' }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BTable } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import formatDate from '@/utils/date-format'

export default {
  components: { BRow, BCol, BTable },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const datesCols = [
      'available',
      'from',
      'to',
    ]
    const tableColumns = [
      'day', 'available', 'from', 'to',
    ]
    const datesArr = computed(() => [{
      available: props.item.availability.specifcDates.available,
      from: formatDate(props.item.availability.specifcDates.from),
      to: formatDate(props.item.availability.specifcDates.to),
    }])
    return {
      datesArr,
      datesCols,
      tableColumns,

    }
  },
}
</script>

<style>

</style>
